import Api from '../../api'
import axios from '@/js/api'
// import Vue from 'vue'
import router from '../../router'
const state = {
	//饼图颜色
	pieColorList:{
		color1:['#7CCACB', '#648CB3','#A79393', '#755765','#37BFA7','#F2F0EE'],
		color2:['#725A7A', '#C56D86', '#FF7582', '#355C7D','#849FAD','#FFE29F','#58B6E6','#FCCC68','#FD9D70','#9AC1FB','#E2D07D'],
		color3:['#F08583', '#91ABA3', '#B4E2C4', '#F6F3CF', '#F6BDB3', '#806154', '#2B538F','#69C2C1','#ECD8C1','#B37470','#47655B','#B1D082']
	},
	visPieColorList:{
		color1:['#2081FF','#1EE3A1','#3BDCF3','#88BCFF','#316EBD','#A3FFE0','#6545FB','#E3B1FF','#AF9AFF','#13A7E8','#204DFF'],
		color2:['#2081FF','#1EE3A1','#3BDCF3','#88BCFF','#316EBD','#A3FFE0','#6545FB','#E3B1FF','#AF9AFF','#13A7E8','#204DFF'],
		color3:['#2081FF','#1EE3A1','#3BDCF3','#88BCFF','#316EBD','#A3FFE0','#6545FB','#E3B1FF','#AF9AFF','#13A7E8','#204DFF']
	},
    detailsRulesParameter:{
		type:[{Text:'影像',Value:1},{Text:'报告',Value:2},{Text:'病史',Value:3}],
		type2:[{Text:'影像',Value:1},{Text:'报告',Value:2},{Text:'影像和报告',Value:3}],
        types:[{Text:'影像',Value:1},{Text:'报告',Value:2},{Text:'影像和报告',Value:3},{Text:'影像报告和病史',Value:4}],
		schemeSearchType:[{Text:'影像',Value:1},{Text:'报告',Value:2},{Text:'影像和报告',Value:3},{Text:'影像报告和病史',Value:4}],
		detailsRulesSearchType:[{Text:'影像',Value:1},{Text:'报告',Value:2},{Text:'病史',Value:3}],
        TypeValue:[{text:'按固定值',value:2},{text:'按比例',value:1}],
        modalityType:[{text:'CT',sorts:1},{text:'MR',sort:2},{text:'DR',sort:3},{text:'US',sort:4},{text:'PET/CT',sort:5},{text:'PET/MR',sort:6}],
        // modalityType:[{text:'CT',sorts:1},{text:'MR',sort:2},{text:'DR',sort:3},{text:'US',sort:4}],
        modalityTypeFilter:[{text:'CT',sort:1},{text:'MR',sort:2},{text:'DR',sort:3},{text:'US',sort:4},{text:'PET-CT',sort:5},{text:'PET-MR',sort:6},{text:'PET/CT',sort:7},{text:'PET/MR',sort:8}],
        IsPositive:[{text:'阳性',value:'1'},{text:'阴性',value:'2'},{text:'未知',value:'0'},],
        ScanType:[{text:'平扫'},{text:'增强'}],
        // BodyPart:[{text:'头部'},{text:'胸部'},{text:'腹部'},{text:'骨肌'},{text:'血管'},{text:'乳腺'}],
		BodyPart:[],
        ScanTypes:[],
        BodyParts:[],
        IsPositives:[],
		mode:[{Text:'减分',Value:2}],
		ScoreItemType:[{Text:'全部',Value:0},{Text:'无',Value:1},{Text:'有',Value:2}],
		OptionList:[]
    },
	modalityTypeSelect:[{text:'全部',sorts:''},{text:'CT',sorts:'CT'},{text:'MR',sorts:'MR'},{text:'DR',sorts:'DR'},{text:'US',sorts:'US'}],
	hospitalGradeList: [{name: '不限',id: 0}, {name: '一级',id: 1}, {name: '二级',id: 2}, {name: '三级',id: 3}],
	reportScreening:[{name:'全部',type:'all'},{name:'CT',type:'modalityType'},{name:'MR',type:'modalityType'},{name:'平扫',type:'scanType'},{name:'增强',type:'scanType'},{name:'头部',type:'bodypart'},{name:'胸部',type:'bodypart'},{name:'腹部',type:'bodypart'}],
	nodeList: [],
	currentMenu: '' /** 当前active导航菜单 */ ,
	/* 面包屑导航列表 */
	crumbList: [],
	breadListState: [], // 面包屑列表数据
	navselected:{
		path:''
	},
	//导航栏开启关闭
	menuStatus:{
		isCollapse: false,
	},
	versionNo:"v4.1.1",
	loading:false,
	localLoading:false,
	qcresultsShow:false,
	tootipType:false,
	qcresultsList:{},
	selectRow:{
		row:1,
		pageIndex:1,
		index:0
	},
	collapseflag:{
		flag:false
	},
	expertflag:{
		flag:false
	},
	// 影像中心数据
	allHospitalsData:{},
	bg:{
		flag:false
	}, //控制大屏背景显示与否
	breadLists:{
		breadList: [],
	},
	checkingList:[],
	checkingParameter:{
	  "HospCode": '',
	  "Key": '',
	  "BodyPart": '',
	  "ScanType": '',
	  "PageIndex": 1,
	  "PageCount": 10
	},
	scanTypesList:[],
	setBodyPartsList:[],
	skinPeeler:{
		status:true
	},
	chartsColor:{
		color:'#FFFFFF'
	},
	isTree:true,
	// 公用参数传值
	commonpars:{
		name:'',
		hospitalGuid:''
	},
	hospitalUsersList:[]
};
const getters = {

};
const mutations = {
	setReportScanType(state, res){
        state.detailsRulesParameter.ScanTypes = res.data.Data;
		state.detailsRulesParameter.ScanTypes.forEach(item=>{
			item.text = item.Name;
		})
	},
	setReportModality(state, res){
        state.detailsRulesParameter.modalityType = res.data.Data;
		state.detailsRulesParameter.modalityType.forEach(item=>{
			item.text = item.Name;
		})
	},
	changeisTree(state,constant){
		state.isTree = constant;
	},
	setSkinPeeler(state, res){
		state.skinPeeler = res;
	},
	setSelectRow(state,arr){
		state.selectRow = arr;
	},
	clearRow(state,arr){
		state.selectRow.row = 1;
		state.selectRow.pageIndex = 1;
		state.selectRow.index = 0;
	},
	setTootipType(state,arr){
		state.tootipType = arr;
	},
	// 详情下拉是否显示
	setqcresultsShow(state,arr){
		state.qcresultsShow = arr;
	},
	// 局部loading
	setlocalLoading(state, val){
		state.localLoading = val;
	},
	setLoading(state, val){
		state.loading = val;
	},
	changenavselected(state, path){
		state.navselected.path = path;
	},
	setNodeList(state, list) {
		state.nodeList.push(list);
		let newobj = {}; 
		state.nodeList = state.nodeList .reduce((preVal, curVal) => {
			newobj[curVal.UniqueId] ? '' : newobj[curVal.UniqueId] = preVal.push(curVal); 
			return preVal 
		}, [])
	},
	setCrumbList(state, list) {
		state.crumbList = list.map((item)=>{
			return {
				path:item.path,
				name:item.name,
				meta:item.meta[0]
			}
		})
	},
	breadListMutations (state, list) {
      state.breadListState = list;
    },
	setAllHospitals (state, res) {
      state.allHospitalsData = res.data;
    },
	setCheckingItems (state, res) {
      state.checkingList = res.data;
    },
	setScanTypes (state, res) {
      state.scanTypesList = res.data;
    },
	setBodyParts (state, res) {
      state.setBodyPartsList = res.data;
	  state.detailsRulesParameter.BodyPart = res.data.Data;
	  state.detailsRulesParameter.BodyPart.forEach(item=>{
		  item.text = item.Name;
	  })
    },
	sethospitalUsersList(state, res){
		state.hospitalUsersList = res.data.Users;
	}
};
const actions = {
    //扫描类型
    GetReportScanType({
        state,
        commit,
        dispatch
    },arr) {
        axios.ajaxGet('get', Api.api.manager.GetReportScanType).then(res => {
            commit('setReportScanType', res);
        })
    },
	//获取影像中心列表
	getAllHospitals({
		state,
		commit,
		dispatch
	},arr) {
		commit('setLoading',true)
		return axios.ajaxGet('get', Api.api.manager.GetAllHospitals, {
			enable: -1,
			name:arr.name,
			pageIndex: arr.pageIndex,
			pageCount: arr.pageCount
		}).then(res => {
			if(res.data.StatusCode){
				commit('setLoading',false)
				commit('setAllHospitals', res);
			}
		}).finally(() => {});
	},
	//获取检查项目列表
	getCheckingItems({
		state,
		commit,
		dispatch
	},arr) {
		commit('setLoading',true)
		axios.ajaxPost('post', Api.api.manager.GetCheckingItems, state.checkingParameter).then(res => {
			if(res.data.StatusCode){
				commit('setLoading',false)
				commit('setCheckingItems', res);
			}
		})
	},
	//导入检查项目
	ImportCheckingItem({
		state,
		commit,
		dispatch
	},arr) {
		commit('setLoading',true)
		return axios.ajaxPost('post', Api.api.manager.ImportCheckingItem, arr).then(res => {
			commit('setLoading',false)
		}).finally(() => {});
	},
	//关联检查项目和扫描方式
	UpdateCheckingItem({
		state,
		commit,
		dispatch
	},arr) {
		commit('setLoading',true)
		return axios.ajaxPost('post', Api.api.manager.UpdateCheckingItem, arr).then(res => {
			commit('setLoading',false)
		}).finally(() => {});
	},
	//获取扫描方式
	GetScanTypes({
		state,
		commit,
		dispatch
	},arr) {
		axios.ajaxGet('get', Api.api.manager.GetScanTypes).then(res => {
			if(res.data.StatusCode){
				commit('setScanTypes', res);
			}
		})
	},
    //设备类型
    GetReportModality({
        state,
        commit,
        dispatch
    },arr) {
        axios.ajaxGet('get', Api.api.manager.GetReportModality).then(res => {
            if(res.data.StatusCode){
                commit('setReportModality', res);
            }
        })
    },
	//获取检查部位
	GetBodyParts({
		state,
		commit,
		dispatch
	},arr) {
		axios.ajaxGet('get', Api.api.manager.GetBodyParts).then(res => {
			if(res.data.StatusCode){
				commit('setBodyParts', res);
			}
		})
	},

	//获取中心管理者
	GetHospitalUsers({
		state,
		commit
	},arr) {
		axios.ajaxGet('get', Api.api.manager.GetHospitalUsers,arr).then(res => {
			if(res.data.StatusCode){
				commit('sethospitalUsersList', res);
			}
		})
	},
	//添加中心管理者
	AddHospitalUser({
		state,
		commit,
		dispatch
	},arr) {
		return axios.ajaxPost('post', Api.api.manager.AddHospitalUser, arr).then(res => {
			ELEMENT.Message.success("添加成功");
		}).finally(() => {});
	},
	//删除中心管理员
	DeleteHospitalUser({
		state,
		commit,
		dispatch
	},arr) {
		return axios.ajaxPost('post', Api.api.manager.DeleteHospitalUser, arr).then(res => {
			ELEMENT.Message.success("删除成功");
		}).finally(() => {});
	},
}
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}